<backbone>
  <section header-page="topbar" class="d-flex justify-content-between gap-2 h-100 position-relative">
    <div class="d-flex justify-content-start align-items-center text-truncate">
      <p class="m-0 fw-medium text-truncate">Vigencia de derecho</p>
    </div>

    <div class="d-flex justify-content-end align-items-center gap-3">
      <breadcrumb [items]="[{ label: 'IMSS' }, { label: 'Vigencia de derecho' }]" />
    </div>
  </section>

  <section wrapper>
    <p-tabView [activeIndex]="0">
      <p-tabPanel tabindex="0" header="Enviar por correo electrónico">
        <ng-template pTemplate="header">
          <div class="d-flex justify-content-center gap-2">
            <span class="font-bold white-space-nowrap m-0">Enviar por correo electrónico</span>
            <p-tag [style]="{ border: '1px solid #4caf50', padding: '0px', gap: '0', background: 'transparent', color: '#4caf50' }">
              <div class="flex items-center gap-0 px-1">
                <span class="text-base font-light text-uppercase" style="font-size: 9px">Nuevo</span>
              </div>
            </p-tag>
          </div>
        </ng-template>
        <page-enviar-email />
      </p-tabPanel>
      <p-tabPanel tabindex="1" header="Subir archivo" *showForRoles="['GESTOR']">
        <page-upload />
      </p-tabPanel>
    </p-tabView>
  </section>
</backbone>
